import React from 'react';
import { ShieldCheck, BadgeCheck } from 'lucide-react';

/**
 * VerifiedBadge - reusable inline badge for student profile + job applications.
 * Props:
 *   isVerified: boolean
 *   planCode: 'basic' | 'pro' | 'elite' (drives color tier)
 *   size: 'sm' | 'md' | 'lg'
 *   showLabel: boolean
 */
const TIER_STYLES = {
  basic:  { bg: 'bg-blue-50',   text: 'text-blue-700',   ring: 'ring-blue-200',   accent: 'bg-blue-600' },
  pro:    { bg: 'bg-purple-50', text: 'text-purple-700', ring: 'ring-purple-200', accent: 'bg-purple-600' },
  elite:  { bg: 'bg-amber-50',  text: 'text-amber-700',  ring: 'ring-amber-300',  accent: 'bg-amber-500' },
  default:{ bg: 'bg-emerald-50',text: 'text-emerald-700',ring: 'ring-emerald-200',accent: 'bg-emerald-600' },
};

const SIZES = {
  sm: { pad: 'px-2 py-0.5', iconSize: 12, text: 'text-xs' },
  md: { pad: 'px-2.5 py-1', iconSize: 14, text: 'text-xs' },
  lg: { pad: 'px-3 py-1.5', iconSize: 16, text: 'text-sm' },
};

const VerifiedBadge = ({ isVerified, planCode = 'default', size = 'md', showLabel = true, className = '' }) => {
  if (!isVerified) return null;
  const tier = TIER_STYLES[planCode] || TIER_STYLES.default;
  const s = SIZES[size] || SIZES.md;
  
  return (
    <span
      title={`EvalentX Verified Talent${planCode !== 'default' ? ` · ${planCode.charAt(0).toUpperCase() + planCode.slice(1)}` : ''}`}
      className={`inline-flex items-center gap-1 ${s.pad} rounded-full ${tier.bg} ${tier.text} ring-1 ${tier.ring} font-semibold ${s.text} ${className}`}
      data-testid="verified-badge"
    >
      <BadgeCheck size={s.iconSize} className={`${tier.text}`} fill="currentColor" strokeWidth={0} />
      <ShieldCheck size={s.iconSize} className="text-white absolute" style={{ display: 'none' }} />
      {showLabel && <span>Verified</span>}
    </span>
  );
};

export default VerifiedBadge;
